/** @format */

import { TDocument, TDocumentComplete } from "../declarations/maps/documents";
import { TStore } from "../declarations/store";

export const selectorDocumentList = (state: TStore): TDocumentComplete[] =>
  state.documents.documentList || [];
